import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import Select from '@adv-mt/mt-form-select'

import {ICONS_BY_LUGGAGE_CAPACITY} from './config.js'

const LEGACY_WRAPPER = 'legacy'

const FormLuggageCapacity = ({
  aggregations,
  initialSearch,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = 0,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {luggageCapacityTypes, FILTER_NAMES, DEFAULT_LUGGAGE_CAPACITY_TYPE} = config.get('search')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {value: selectedId}) => {
    const selectedLuggageCapacity = luggageCapacityTypes.find(option => option.id === selectedId)

    onChange(e, {
      field: FILTER_NAMES.LUGGAGE_CAPACITY,
      value: selectedLuggageCapacity.value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.LUGGAGE_CAPACITY]
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [firstValue] = selectedValue
    _handleOnChange(null, {value: Number(firstValue)})
  }

  const localizedLuggageCapacity = luggageCapacityTypes.map(({id, label}) => ({
    icon: ICONS_BY_LUGGAGE_CAPACITY[id],
    id,
    label: i18n.t(label)
  }))

  const selectedLuggageCapacity = luggageCapacityTypes.find(
    type => JSON.stringify(type.value) === JSON.stringify(value)
  )

  const currentValue = selectedLuggageCapacity ? selectedLuggageCapacity.id : DEFAULT_LUGGAGE_CAPACITY_TYPE

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <Select
        aggregations={aggregations}
        field={FILTER_NAMES.LUGGAGE_CAPACITY}
        initialSearch={initialSearch}
        label={i18n.t('SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE')}
        options={localizedLuggageCapacity}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
        value={currentValue}
        onChange={_handleOnChange}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE'),
          name: FILTER_NAMES.LUGGAGE_CAPACITY,
          options: localizedLuggageCapacity,
          showLabel: true,
          type
        }
      ]}
      group={`${FILTER_NAMES.LUGGAGE_CAPACITY}Group`}
      legend={i18n.t('SEARCH_BOX_SELECT_LUGGAGE_CAPACITY_TYPE')}
      onChange={handleChange}
      overlayContentRef={overlayContentRef}
      placeholder={selectedLuggageCapacity ? i18n.t(selectedLuggageCapacity?.label) : i18n.t('COMMON.ALL')}
      showLegend={withLabel}
      value={{[FILTER_NAMES.LUGGAGE_CAPACITY]: [selectedLuggageCapacity?.id || currentValue]}}
      wrapper={wrapper}
    />
  )
}

FormLuggageCapacity.displayName = 'FormLuggageCapacity'
FormLuggageCapacity.propTypes = {
  aggregations: PropTypes.array,
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormLuggageCapacity
